// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Onboarding wizard — two-panel redesign (2026-06-23).
 * Dark brand rail (vertical stepper) + light form panel. Consumes redesign.css
 * tokens; adds a few onboarding-scoped tokens (brand tint, on-dark text).
 * Presentation only — step logic / validation / routing unchanged.
 */

.ob-shell {
  /* onboarding-scoped tokens (reuse the redesign.css brand ramp) */
  --brand-tint: #f4f2ff;
  --t-on-dark: #edeefb;
  --t-on-dark-dim: #a7abcf;

  display: grid;
  grid-template-columns: 392px 1fr;
  min-height: 100vh;
  background: var(--bg-app, #f4f5fb);
  color: var(--ink, #0e1124);
}

/* =====================================================================
   LEFT BRAND RAIL
   ===================================================================== */
.ob-rail {
  position: sticky;
  top: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 34px 34px 28px;
  border-right: 1px solid rgba(255, 255, 255, 0.05);
  /* Deep blue rail against the light panel. The violet and mint glows keep it
     from reading as flat navy. */
  background:
    radial-gradient(120% 55% at 0% 0%, rgba(139, 123, 255, 0.3), transparent 60%),
    radial-gradient(80% 50% at 100% 100%, rgba(15, 185, 129, 0.14), transparent 55%),
    linear-gradient(180deg, #12142e, #0a0c18);
  color: var(--t-on-dark);
}

/* The real lockup, not a CSS letter mark. The rail is dark, so it takes
   maxelpay-logo-light.svg (the white one). The preparing screen is light and
   uses the -dark.svg variant instead. */
.ob-logo {
  display: inline-block;
  text-decoration: none;
}

.ob-logo img {
  height: 34px;
  width: auto;
  display: block;
}

.ob-rail-headline {
  margin: 40px 0 30px;
}

.ob-rail-headline h2 {
  font-family: var(--font-display);
  font-size: 23px;
  font-weight: 700;
  line-height: 1.25;
  color: #fff;
}

.ob-rail-headline p {
  margin-top: 10px;
  font-size: 13.5px;
  line-height: 1.5;
  color: var(--t-on-dark-dim);
}

.ob-rail-foot {
  margin-top: auto;
}

.ob-reassure {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  background: rgba(255, 255, 255, 0.05);
  /* border: 1px solid rgba(255, 255, 255, 0.08); */
  border-radius: 12px;
  padding: 14px 16px;
}

.ob-reassure-icon {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: rgba(15, 185, 129, 0.16);
  color: #4fe3ab;
  flex-shrink: 0;
}

.ob-reassure div {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.ob-reassure a {
    color: #a99cff;
    text-decoration: unset;
}
.ob-reassure a:hover {
    color: #ffffff;
    text-decoration: unset;
}
.ob-reassure strong {
  font-size: 13.5px;
  font-weight: 700;
  color: #fff;
}

.ob-reassure span {
  font-size: 12px;
  color: var(--t-on-dark-dim);
}

/* A <button>, not a link, since it writes before it navigates. The reset keeps
   it looking exactly like the link it replaced. */
.ob-exit {
  display: inline-block;
  margin-top: 16px;
  padding: 0;
  border: none;
  background: none;
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--brand-400, #a99cff);
  text-decoration: none;
  cursor: pointer;
}

.ob-exit:disabled {
  opacity: 0.6;
  cursor: default;
}

.ob-exit:hover {
  color: #fff;
}

/* =====================================================================
   VERTICAL STEPPER
   ===================================================================== */
.ob-stepper {
  list-style: none;
  margin: 0;
  padding: 0;
}

.ob-step {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 9px 0;
}

/* connector above each node */
.ob-step::before {
  content: '';
  position: absolute;
  left: 14.5px;
  top: -9px;
  height: 18px;
  width: 2px;
  background: rgba(255, 255, 255, 0.1);
}

.ob-step:first-child::before {
  display: none;
}

.ob-step.seg-done::before {
  background: rgba(15, 185, 129, 0.5);
}

.ob-step-node {
  position: relative;
  z-index: 1;
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-family: var(--font-display);
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  border: 2px solid rgba(255, 255, 255, 0.18);
  color: var(--t-on-dark-dim);
  background: transparent;
}

.ob-step.done .ob-step-node {
  background: var(--ok, #0fb981);
  border-color: transparent;
  color: #fff;
}

.ob-step.current .ob-step-node {
  background: var(--grad-primary, linear-gradient(135deg, #8270ff, #5847d6));
  border-color: transparent;
  color: #fff;
  box-shadow: 0 0 0 5px rgba(109, 93, 246, 0.22);
}

.ob-step-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 5px;
  min-width: 0;
}

.ob-step-label {
  font-size: 14.5px;
  font-weight: 600;
  color: var(--t-on-dark-dim);
}

.ob-step.current .ob-step-label {
  color: #fff;
  font-weight: 700;
}

.ob-step.done .ob-step-label {
  color: var(--t-on-dark);
}

.ob-step-caption {
  display: block;
  font-size: 11.5px;
  color: var(--t-on-dark-dim);
}

/* ═══ Stepper tail: "Preparing your dashboard" ══════════════════════════════
   Replaces what used to be three more numbered circles. Dim and static until
   the merchant is past step 3, then it animates.

   The motion is deliberately restrained: a slow arc sweep on the node, a
   shimmer across the label, and a slim indeterminate bar. No percentage, no
   bounce. It says "working" without pretending to know how long.
   ═════════════════════════════════════════════════════════════════════════ */

.ob-tail { align-items: center; }

/* Node: a hollow ring holding a rotating arc and a centre dot. */
.ob-tail-node {
  position: relative;
  z-index: 1;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.18);
  background: transparent;
}
.ob-tail-arc {
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  border: 2px solid transparent;
  /* One visible quarter, so the rotation reads as a sweep rather than a spin
     of the whole ring. */
  border-top-color: var(--accent, #6d5df6);
  opacity: 0;
}
.ob-tail-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.24);
}

.ob-tail-label {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--t-on-dark-dim, #a7abcf);
}

/* Indeterminate bar. Zero height until active so the row does not shift. */
.ob-tail-bar {
  display: block;
  margin-top: 8px;
  height: 0;
  width: 132px;
  max-width: 100%;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;
  opacity: 0;
  transition: height 0.25s ease, opacity 0.25s ease;
}
.ob-tail-bar i {
  display: block;
  height: 100%;
  width: 38%;
  border-radius: 999px;
  background: linear-gradient(90deg, transparent, var(--accent, #6d5df6), transparent);
}

/* ── Active state ─────────────────────────────────────────────────────── */

.ob-tail.is-active .ob-tail-node {
  border-color: rgba(109, 93, 246, 0.32);
  box-shadow: 0 0 0 5px rgba(109, 93, 246, 0.14);
}
.ob-tail.is-active .ob-tail-arc {
  opacity: 1;
  animation: ob-tail-spin 1.15s linear infinite;
}
.ob-tail.is-active .ob-tail-dot {
  background: var(--accent, #6d5df6);
  animation: ob-tail-breathe 1.9s ease-in-out infinite;
}

/* Shimmer reads as work in progress. The gradient needs a text clip, so the
   colour comes from the gradient and not from the token. */
.ob-tail.is-active .ob-tail-label {
  /* Light-on-dark: the highlight is white against the dimmed rail text. */
  background: linear-gradient(
    100deg,
    #a7abcf 0%,
    #a7abcf 38%,
    #ffffff 50%,
    #a7abcf 62%,
    #a7abcf 100%
  );
  background-size: 220% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: ob-tail-shimmer 2.4s linear infinite;
}

.ob-tail.is-active .ob-tail-bar { height: 3px; opacity: 1; }
.ob-tail.is-active .ob-tail-bar i { animation: ob-tail-slide 1.7s ease-in-out infinite; }

@keyframes ob-tail-spin { to { transform: rotate(360deg); } }
@keyframes ob-tail-breathe {
  0%, 100% { transform: scale(1); opacity: 0.85; }
  50% { transform: scale(1.28); opacity: 1; }
}
@keyframes ob-tail-shimmer {
  0% { background-position: 130% 0; }
  100% { background-position: -30% 0; }
}
@keyframes ob-tail-slide {
  0% { transform: translateX(-105%); }
  100% { transform: translateX(272%); }
}

/* Someone who opted out of motion still needs to know it is working, so the
   label keeps a trailing ellipsis and the bar shows a static partial fill. */
@media (prefers-reduced-motion: reduce) {
  .ob-tail.is-active .ob-tail-arc,
  .ob-tail.is-active .ob-tail-dot,
  .ob-tail.is-active .ob-tail-label,
  .ob-tail.is-active .ob-tail-bar i { animation: none; }
  .ob-tail.is-active .ob-tail-label {
    background: none;
    -webkit-text-fill-color: currentColor;
    color: #fff;
  }
  .ob-tail.is-active .ob-tail-label::after { content: '\\2026'; }
  .ob-tail.is-active .ob-tail-bar i { width: 55%; transform: none; }
}


.ob-logo-image {
    max-width: 180px;
}
.ob-visually-hidden,
.wiz-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* =====================================================================
   RIGHT FORM PANEL
   ===================================================================== */
.ob-panel {
  overflow-y: auto;
  max-height: 100vh;
  padding: 42px 40px 48px;
  background: var(--bg-app, #f4f5fb);
}

/* Step content container (WizardCard renders <section class="wiz-card">). The
   panel is the surface, so this is a plain centered column, not a boxed card. */
.wiz-card {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
}

/* =====================================================================
   PROGRESS HEADER (top of every step)
   ===================================================================== */
.ob-progress {
  margin-bottom: 30px;
}

.ob-progress-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.ob-progress-step {
  font-size: 12.5px;
  font-weight: 700;
  color: var(--brand-700, #5847d6);
}

.ob-progress-pct {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--ink-muted, #9aa0b6);
}

.ob-progress-track {
  height: 6px;
  background: var(--line, #eaebf3);
  border-radius: 20px;
  overflow: hidden;
}

.ob-progress-fill {
  height: 100%;
  border-radius: 20px;
  background: linear-gradient(90deg, var(--brand-500, #8b7bff), var(--brand-600, #6d5df6));
  transition: width 0.3s ease;
}

/* =====================================================================
   STEP HEADING + BODY
   ===================================================================== */
.wiz-card-head {
  margin-bottom: 24px;
}

.wiz-title {
  font-family: var(--font-display);
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ink, #0e1124);
  line-height: 1.2;
}

.wiz-title:focus {
  outline: none;
}

.wiz-title:focus-visible {
  outline: 2px solid var(--brand-400, #a99cff);
  outline-offset: 4px;
  border-radius: 4px;
}

.wiz-subtitle {
  margin-top: 8px;
  font-size: 14.5px;
  color: var(--ink-secondary, #6c7189);
  line-height: 1.5;
}

.wiz-card-body {
  margin-bottom: 4px;
}

.wiz-form-error {
  margin-top: 16px;
  font-size: 13px;
  color: var(--err-ink, #ce2649);
  background: var(--err-soft, #fdebef);
  border: 1px solid var(--err-soft, #fdebef);
  border-radius: var(--r-md, 12px);
  padding: 12px 14px;
}

/* ---- Fields (reuse global .rd-field / .rd-input / .rd-select) ---- */
.wiz-field {
  margin-bottom: 18px;
}

.wiz-field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

/* =====================================================================
   FOOTER ACTIONS
   ===================================================================== */
.wiz-actions {
  display: flex;
  align-items: center;
  gap: 20px;
  border-top: 1px solid var(--line, #eaebf3);
  padding-top: 24px;
  margin-top: 34px;
}

.wiz-actions-quiet {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-right: auto; /* pushes the primary action to the right */
}

.wiz-link {
  background: none;
  border: none;
  padding: 6px 2px;
  color: var(--ink-secondary, #6c7189);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  font-family: var(--iv-sans);
}

.wiz-link:hover {
  color: var(--ink, #0e1124);
}

/* Continue — brand gradient with a softened lift */
.wiz-primary.rd-btn,
.wiz-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 46px;
  padding: 13px 28px;
  border: none;
  border-radius: var(--r-md, 12px);
  color: #fff;
  font-weight: 700;
  font-size: 14.5px;
  background: var(--grad-primary, linear-gradient(135deg, #8270ff, #5847d6));
  box-shadow: 0 8px 22px rgba(109, 93, 246, 0.28);
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.wiz-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 10px 26px rgba(109, 93, 246, 0.34);
}

.wiz-primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
  font-family: var(--iv-sans);
}

.wiz-secondary {
  margin-top: 18px;
  text-align: center;
  font-size: 14px;
}

.wiz-secondary button,
.wiz-secondary a {
  background: none;
  border: none;
  color: var(--brand-600, #6d5df6);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
}

.wiz-secondary button:hover,
.wiz-secondary a:hover {
  text-decoration: underline;
}

/* =====================================================================
   SELECTABLE OPTION CARD (multi-select grid + single-select radio row)
   One selection signal only — the styled input carries it.
   ===================================================================== */
.sel-card {
  display: flex;
  align-items: center;
  gap: 13px;
  min-height: 84px;
  padding: 16px 18px;
  border: 1.5px solid var(--line, #eaebf3);
  border-radius: var(--r-lg, 16px);
  background: var(--surface, #fff);
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
}

.sel-card:hover {
  border-color: var(--brand-400, #a99cff);
  box-shadow: var(--sh-card, 0 1px 2px rgba(16, 18, 40, 0.04), 0 6px 22px rgba(16, 18, 40, 0.045));
}

.sel-card.selected {
  border-color: var(--brand-600, #6d5df6);
  background: var(--brand-tint, #f4f2ff);
  box-shadow: 0 0 0 3px rgba(109, 93, 246, 0.1);
}

.sel-card:focus-within {
  box-shadow: 0 0 0 3px rgba(109, 93, 246, 0.3);
}

/* styled real input (checkbox for multi, radio for single) */
.sel-card-input {
  appearance: none;
  -webkit-appearance: none;
  position: relative;
  width: 22px;
  height: 22px;
  margin: 0;
  flex-shrink: 0;
  border: 2px solid var(--border-strong, #dddfec);
  border-radius: 7px;
  background: #fff;
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: background 0.15s, border-color 0.15s;
}

.sel-card-input:checked {
  background: var(--brand-600, #6d5df6);
  border-color: var(--brand-600, #6d5df6);
}

.sel-card-input[type='checkbox']:checked::after {
  content: '';
  width: 5px;
  height: 9px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: translateY(-1px) rotate(45deg);
}

/* single-select row uses a radio */
.sel-card.compact {
  min-height: 0;
  padding: 15px 18px;
  border-radius: var(--r-md, 12px);
}

.sel-card.compact .sel-card-input {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}

.sel-card.compact .sel-card-input:checked::after {
  content: '';
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fff;
}

.sel-card-icon {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: var(--brand-100, #ece9ff);
  color: var(--brand-700, #5847d6);
  flex-shrink: 0;
}

.sel-card.compact .sel-card-icon {
  width: 28px;
  height: 28px;
  border-radius: 9px;
}

.sel-card-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
  min-width: 0;
}

.sel-card-label {
  font-size: 14.5px;
  font-weight: 600;
  color: var(--ink, #0e1124);
}

.sel-card-desc {
  font-size: 13px;
  color: var(--ink-secondary, #6c7189);
  line-height: 1.4;
}

/* =====================================================================
   USE-CASE GRID / FIELDSETS / PRIMARY SELECTOR / OPTIONAL SECTION
   ===================================================================== */
.wiz-usecase-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.wiz-fieldset {
  border: none;
  padding: 0;
  margin: 0;
}

.wiz-primary-row {
  margin-top: 28px;
}

.wiz-primary-legend {
  display: flex;
  align-items: center;
  gap: 12px;
  font-family: var(--font-display);
  font-size: 15px;
  font-weight: 700;
  color: var(--ink, #0e1124);
  margin-bottom: 14px;
  padding: 0;
  width: 100%;
}

.wiz-primary-legend::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: var(--line, #eaebf3);
}

.wiz-primary-options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wiz-optional {
  margin-top: 28px;
}

.wiz-optional-divider {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--ink-muted, #9aa0b6);
  margin-bottom: 14px;
}

/* =====================================================================
   VERIFY (activation handoff) BLOCK
   ===================================================================== */
.wiz-handoff {
  display: flex;
  gap: 14px;
  align-items: flex-start;
  padding: 18px;
  background: var(--brand-tint, #f4f2ff);
  border: 1px solid var(--brand-100, #ece9ff);
  border-radius: var(--r-lg, 16px);
}

.wiz-handoff-icon {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: var(--r-md, 12px);
  background: #fff;
  color: var(--brand-700, #5847d6);
  flex-shrink: 0;
}

.wiz-handoff p {
  font-size: 14px;
  line-height: 1.55;
  color: var(--ink-secondary, #6c7189);
}

/* =====================================================================
   TEST-PAYMENT OPTIONS / CODE / STATUS PILL
   ===================================================================== */
.wiz-tp-options {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 18px;
}

.wiz-tp-option {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  text-align: left;
  padding: 16px 18px;
  border: 1.5px solid var(--line, #eaebf3);
  border-radius: var(--r-lg, 16px);
  background: var(--surface, #fff);
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
  font-family: var(--iv-sans);
}

.wiz-tp-option:hover {
  border-color: var(--brand-400, #a99cff);
  box-shadow: var(--sh-card, 0 6px 22px rgba(16, 18, 40, 0.045));
}

.wiz-tp-option-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.wiz-tp-option-title {
  font-size: 14.5px;
  font-weight: 700;
  color: var(--ink, #0e1124);
}

.wiz-tp-option-desc {
  font-size: 13px;
  line-height: 1.45;
  color: var(--ink-secondary, #6c7189);
}

.wiz-tp-code {
  margin-bottom: 18px;
  background: var(--ink-900, #0c0e1d);
  border-radius: var(--r-md, 12px);
  padding: 16px 18px;
}

.wiz-tp-code pre {
  margin: 0;
  font-family: var(--font-mono);
  font-size: 12.5px;
  line-height: 1.6;
  color: var(--t-on-dark, #edeefb);
  white-space: pre-wrap;
  word-break: break-word;
}

.wiz-pill {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  border-radius: var(--r-md, 12px);
  border: 1px solid var(--line, #eaebf3);
  background: var(--bg-inset, #f1f2f8);
  font-size: 14px;
  font-weight: 600;
  color: var(--ink-secondary, #6c7189);
}

.wiz-pill.pending {
  border-color: var(--warn-soft, #fef3e0);
  background: var(--warn-soft, #fef3e0);
  color: var(--warn-ink, #b9760a);
}

.wiz-pill.succeeded {
  border-color: var(--ok-soft, #e6f8f1);
  background: var(--ok-soft, #e6f8f1);
  color: var(--ok-ink, #0a8f64);
}

.wiz-pill.failed {
  border-color: var(--err-soft, #fdebef);
  background: var(--err-soft, #fdebef);
  color: var(--err-ink, #ce2649);
}

.wiz-pill-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: currentColor;
  flex-shrink: 0;
  animation: wizPulse 1.2s ease-in-out infinite;
}

@keyframes wizPulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.4; transform: scale(0.7); }
}

.wiz-retry-row {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 16px;
}

.wiz-retry-row .rd-btn {
  min-width: 140px;
}

/* =====================================================================
   SUCCESS ("You're all set") — arrival state
   ===================================================================== */
.wiz-success-badge {
  display: grid;
  place-items: center;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  margin: 0 auto 22px;
  background: var(--ok-soft, #e6f8f1);
  color: var(--ok, #0fb981);
  box-shadow: 0 0 0 8px rgba(15, 185, 129, 0.08);
}

/* =====================================================================
   LOADING SKELETON
   ===================================================================== */
.wiz-skeleton {
  height: 16px;
  border-radius: 6px;
  background: linear-gradient(90deg, #eef0f4 25%, #e2e6ee 37%, #eef0f4 63%);
  background-size: 400% 100%;
  animation: wizShimmer 1.4s ease infinite;
}

.wiz-skeleton.block {
  height: 56px;
}

@keyframes wizShimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}

/* =====================================================================
   PLAN STEP — pricing cards on the selectable-card pattern
   ===================================================================== */
.wiz-plan {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
}

.wiz-plan-head {
  margin-bottom: 26px;
}

.wiz-plan-title {
  font-family: var(--font-display);
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--ink, #0e1124);
}

.wiz-plan-sub {
  margin-top: 8px;
  font-size: 14.5px;
  color: var(--ink-secondary, #6c7189);
}

.wiz-plan-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  align-items: start;
}

.wiz-plan-card {
  position: relative;
  padding: 24px 22px;
  display: flex;
  flex-direction: column;
  border: 1.5px solid var(--line, #eaebf3);
  border-radius: var(--r-lg, 16px);
  background: var(--surface, #fff);
}

.wiz-plan-card.recommended {
  border-color: var(--brand-600, #6d5df6);
  background: var(--brand-tint, #f4f2ff);
  box-shadow: 0 0 0 3px rgba(109, 93, 246, 0.1);
}

.wiz-plan-pill {
  position: absolute;
  top: -11px;
  left: 22px;
  white-space: nowrap;
  background: var(--grad-primary, linear-gradient(135deg, #8270ff, #5847d6));
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  padding: 5px 11px;
  border-radius: var(--r-pill, 999px);
  box-shadow: 0 6px 16px rgba(109, 93, 246, 0.3);
}

.wiz-plan-card-head {
  margin-bottom: 16px;
}

.wiz-plan-name {
  font-family: var(--font-display);
  font-size: 18px;
  font-weight: 700;
  color: var(--ink, #0e1124);
}

.wiz-plan-card.recommended .wiz-plan-name {
  color: var(--brand-700, #5847d6);
}

.wiz-plan-tagline {
  margin-top: 4px;
  font-size: 13px;
  color: var(--ink-secondary, #6c7189);
}

.wiz-plan-price {
  display: flex;
  align-items: baseline;
  gap: 4px;
  padding-bottom: 14px;
  margin-bottom: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.wiz-plan-currency {
  font-family: var(--font-display);
  font-size: 22px;
  font-weight: 700;
  color: var(--ink-muted, #9aa0b6);
}

.wiz-plan-amount {
  font-family: var(--font-display);
  font-size: 40px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.02em;
  color: var(--ink, #0e1124);
}

.wiz-plan-amount.text {
  font-size: 30px;
}

.wiz-plan-period {
  font-size: 13px;
  color: var(--ink-muted, #9aa0b6);
}

.wiz-plan-fee {
  font-size: 13px;
  color: var(--ink-secondary, #6c7189);
  margin-bottom: 18px;
}

.wiz-plan-fee-value {
  font-family: var(--font-mono);
  font-weight: 700;
  color: var(--ink, #0e1124);
}

.wiz-plan-card.recommended .wiz-plan-fee-value {
  color: var(--brand-700, #5847d6);
}

.wiz-plan-fee-save {
  color: var(--brand-600, #6d5df6);
  font-weight: 600;
}

.wiz-plan-cta {
  min-height: 44px;
}

.wiz-plan-cta-note {
  margin-top: 8px;
  text-align: center;
  font-size: 12px;
  color: var(--ink-muted, #9aa0b6);
}

.wiz-plan-features {
  margin-top: 18px;
}

.wiz-plan-features-heading {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--ink-muted, #9aa0b6);
  margin-bottom: 12px;
}

.wiz-plan-features ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wiz-plan-features li {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  font-size: 13px;
  line-height: 1.45;
  color: var(--ink-secondary, #6c7189);
}

.wiz-plan-features li svg {
  color: var(--ok, #0fb981);
  flex-shrink: 0;
  margin-top: 2px;
}

.wiz-plan-features li.muted {
  color: var(--ink-muted, #9aa0b6);
}

.wiz-plan-features li.muted svg {
  color: var(--ink-muted, #c7cbdb);
}

.wiz-plan-foot {
  display: flex;
  justify-content: flex-start;
  border-top: 1px solid var(--line, #eaebf3);
  padding-top: 24px;
  margin-top: 28px;
}

/* =====================================================================
   RESPONSIVE  (≤900px → single column; rail becomes a slim top bar)
   ===================================================================== */
@media (min-width: 768px) {
  .wiz-plan-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

@media (max-width: 900px) {
  .ob-shell {
    grid-template-columns: 1fr;
  }

  .ob-rail {
    position: static;
    height: auto;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    padding: 14px 18px;
    border-right: none;
    border-bottom: 1px solid var(--line, #eaebf3);
  }

  .ob-logo {
    flex-shrink: 0;
  }

  /* hide everything except the step nodes */
  .ob-rail-headline,
  .ob-rail-foot,
  .ob-step-text,
  .ob-tail-text {
    display: none;
  }

  .ob-stepper {
    display: flex;
    align-items: center;
    gap: 0;
    overflow-x: auto;
    flex: 1 1;
    -webkit-overflow-scrolling: touch;
  }

  .ob-step {
    padding: 0 20px 0 0;
    flex-shrink: 0;
  }

  /* Tail keeps its node in the strip; its label lives in .ob-tail-text, hidden
     above, so the animating ring is the whole signal on narrow screens. */
  .ob-tail { padding-right: 0; }

  .ob-step::before {
    left: -20px;
    top: 14px;
    height: 2px;
    width: 20px;
  }

  .ob-step:first-child::before {
    display: none;
  }

  .ob-panel {
    max-height: none;
    overflow-y: visible;
    padding: 28px 18px 40px;
  }

  .wiz-title {
    font-size: 23px;
  }

  .wiz-usecase-grid,
  .wiz-tp-options,
  .wiz-field-row {
    grid-template-columns: 1fr;
  }

  .wiz-plan-grid {
    grid-template-columns: 1fr;
  }

  .wiz-actions {
    flex-wrap: wrap;
    gap: 12px;
  }

  .wiz-primary {
    width: 100%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .wiz-primary,
  .ob-progress-fill,
  .sel-card,
  .sel-card-input,
  .wiz-tp-option,
  .wiz-pill-dot,
  .wiz-skeleton {
    transition: none;
    animation: none;
  }
}


/* ═══ Preparing screen ══════════════════════════════════════════════════════
   Full-bleed handoff between the wizard and the dashboard. Same brand ground as
   the rail, so leaving setup is a continuation rather than a jump.
   ═════════════════════════════════════════════════════════════════════════ */

.ob-prep {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 40px 24px;
  /* Light ground, matching the rail the merchant just left. */
  background:
    radial-gradient(90% 45% at 50% 0%, rgba(109, 93, 246, 0.09), transparent 64%),
    var(--surface, #ffffff);
  color: var(--ink, #0e1124);
  font-family: var(--font-sans);
}

.ob-prep-inner {
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.ob-prep-logo {
  display: inline-block;
  margin-bottom: 42px;
}

.ob-prep-logo img {
  height: 34px;
  width: auto;
  display: block;
}

/* Ring: one sweeping arc around a soft core. Bigger sibling of the rail tail. */
.ob-prep-ring {
  position: relative;
  width: 62px;
  height: 62px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  border: 2px solid var(--line, #eaebf3);
}
.ob-prep-arc {
  position: absolute;
  inset: -2px;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: var(--accent, #6d5df6);
  animation: ob-prep-spin 1.05s linear infinite;
}
.ob-prep-core {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: var(--grad-primary, linear-gradient(135deg, #8270ff, #5847d6));
  box-shadow: 0 0 20px rgba(109, 93, 246, 0.45);
  animation: ob-prep-breathe 1.9s ease-in-out infinite;
}
@keyframes ob-prep-spin { to { transform: rotate(360deg); } }
@keyframes ob-prep-breathe {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.2); }
}

.ob-prep-title {
  margin: 26px 0 0;
  font-family: var(--font-display);
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: var(--ink, #0e1124);
}
.ob-prep-sub {
  margin: 9px 0 0;
  font-size: 13.5px;
  color: var(--ink-muted, #6c7189);
}

/* Task list. Left-aligned inside a centred column: a ticking checklist reads as
   a list, and centring it makes the ticks wander as labels change width. */
.ob-prep-tasks {
  list-style: none;
  margin: 30px 0 0;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2px;
  text-align: left;
}
.ob-prep-task {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 9px 12px;
  border-radius: 10px;
  font-size: 13.5px;
  color: var(--t-400, #9aa0b6);
  transition: color 0.3s ease, background 0.3s ease;
}
.ob-prep-task.is-active {
  color: var(--ink, #0e1124);
  background: var(--accent-soft, #ece9ff);
}
.ob-prep-task.is-done { color: var(--ink-secondary, #3b4059); }

.ob-prep-tick {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  display: grid;
  place-items: center;
  border-radius: 50%;
  border: 1.5px solid var(--line-strong, #dddfec);
  color: #fff;
  transition: background 0.3s ease, border-color 0.3s ease;
}
.ob-prep-task.is-done .ob-prep-tick {
  background: var(--ok, #0fb981);
  border-color: transparent;
}
/* The active row's marker pulses so the eye knows which line is live. */
.ob-prep-task.is-active .ob-prep-tick {
  border-color: var(--accent, #6d5df6);
  animation: ob-prep-pulse 1.2s ease-in-out infinite;
}
@keyframes ob-prep-pulse {
  0%, 100% { box-shadow: 0 0 0 0 rgba(109, 93, 246, 0.35); }
  50% { box-shadow: 0 0 0 5px rgba(109, 93, 246, 0); }
}

.ob-prep-bar {
  display: block;
  margin-top: 30px;
  width: 100%;
  height: 3px;
  border-radius: 999px;
  background: var(--bg-inset, #eff0f8);
  overflow: hidden;
}
.ob-prep-bar i {
  display: block;
  height: 100%;
  width: 34%;
  border-radius: 999px;
  background: linear-gradient(90deg, transparent, var(--accent, #6d5df6), transparent);
  animation: ob-prep-slide 1.6s ease-in-out infinite;
}
@keyframes ob-prep-slide {
  0% { transform: translateX(-105%); }
  100% { transform: translateX(300%); }
}

/* Reduced motion: the component already renders every task done and exits
   quickly, so this only has to stop the decoration. */
@media (prefers-reduced-motion: reduce) {
  .ob-prep-arc,
  .ob-prep-core,
  .ob-prep-bar i,
  .ob-prep-task.is-active .ob-prep-tick { animation: none; }
  .ob-prep-arc { border-top-color: var(--accent, #6d5df6); opacity: 0.7; }
  .ob-prep-bar i { width: 100%; transform: none; }
  .ob-prep-task { transition: none; }
}

@media (max-width: 520px) {
  .ob-prep-logo { margin-bottom: 32px; }
  .ob-prep-title { font-size: 20px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/onboarding/onboarding.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,iEAAiE;EACjE,qBAAqB;EACrB,oBAAoB;EACpB,wBAAwB;;EAExB,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;;0EAE0E;AAC1E;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iDAAiD;EACjD;iCAC+B;EAC/B;;;6CAG2C;EAC3C,uBAAuB;AACzB;;AAEA;;wCAEwC;AACxC;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,qCAAqC;EACrC,iDAAiD;EACjD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;IACI,cAAc;IACd,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,sBAAsB;AAC1B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;kDACkD;AAClD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;0EAE0E;AAC1E;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,0EAA0E;EAC1E,yBAAyB;EACzB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;;;;;;;8EAO8E;;AAE9E,WAAW,mBAAmB,EAAE;;AAEhC,iEAAiE;AACjE;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B;yBACuB;EACvB,wCAAwC;EACxC,UAAU;AACZ;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA,2EAA2E;AAC3E;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,UAAU;EACV,iDAAiD;AACnD;AACA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,oFAAoF;AACtF;;AAEA,4EAA4E;;AAE5E;EACE,sCAAsC;EACtC,8CAA8C;AAChD;AACA;EACE,UAAU;EACV,6CAA6C;AAC/C;AACA;EACE,kCAAkC;EAClC,oDAAoD;AACtD;;AAEA;2DAC2D;AAC3D;EACE,wEAAwE;EACxE;;;;;;;GAOC;EACD,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA,kCAAkC,WAAW,EAAE,UAAU,EAAE;AAC3D,oCAAoC,kDAAkD,EAAE;;AAExF,0BAA0B,KAAK,yBAAyB,EAAE,EAAE;AAC5D;EACE,WAAW,mBAAmB,EAAE,aAAa,EAAE;EAC/C,MAAM,sBAAsB,EAAE,UAAU,EAAE;AAC5C;AACA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,2BAA2B,EAAE;AACtC;AACA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;6EAC6E;AAC7E;EACE;;;sCAGoC,eAAe,EAAE;EACrD;IACE,gBAAgB;IAChB,qCAAqC;IACrC,WAAW;EACb;EACA,2CAA2C,gBAAgB,EAAE;EAC7D,oCAAoC,UAAU,EAAE,eAAe,EAAE;AACnE;;;AAGA;IACI,gBAAgB;AACpB;AACA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;;0EAE0E;AAC1E;EACE,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;gFACgF;AAChF;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;0EAE0E;AAC1E;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,wFAAwF;EACxF,2BAA2B;AAC7B;;AAEA;;0EAE0E;AAC1E;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,oCAAoC;EACpC,0CAA0C;EAC1C,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA,uEAAuE;AACvE;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB,EAAE,2CAA2C;AACjE;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mDAAmD;AACnD;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,0EAA0E;EAC1E,+CAA+C;EAC/C,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;;0EAG0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;EACf,kEAAkE;AACpE;;AAEA;EACE,uCAAuC;EACvC,gGAAgG;AAClG;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;EACd,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,yCAAyC;AAC3C;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,SAAO;EACP,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,sCAAsC;EACtC,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;EACf,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,sCAAsC;EACtC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;EACvC,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,MAAM,YAAY,EAAE,qBAAqB,EAAE;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;0EAE0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;;0EAE0E;AAC1E;EACE,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,KAAK,6BAA6B,EAAE;EACpC,OAAO,0BAA0B,EAAE;AACrC;;AAEA;;0EAE0E;AAC1E;EACE,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,mBAAmB;EACnB,0EAA0E;EAC1E,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,0CAA0C;EAC1C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;0EAE0E;AAC1E;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,6CAA6C;EAC/C;;EAEA;IACE,cAAc;EAChB;;EAEA,0CAA0C;EAC1C;;;;IAIE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,gBAAgB;IAChB,SAAO;IACP,iCAAiC;EACnC;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;0EACwE;EACxE,WAAW,gBAAgB,EAAE;;EAE7B;IACE,WAAW;IACX,SAAS;IACT,WAAW;IACX,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;;;;;;;IAOE,gBAAgB;IAChB,eAAe;EACjB;AACF;;;AAGA;;;8EAG8E;;AAE9E;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,4DAA4D;EAC5D;;2BAEyB;EACzB,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,wCAAwC;EACxC,6CAA6C;AAC/C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0EAA0E;EAC1E,6CAA6C;EAC7C,oDAAoD;AACtD;AACA,0BAA0B,KAAK,yBAAyB,EAAE,EAAE;AAC5D;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;2EAC2E;AAC3E;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,iDAAiD;AACnD;AACA;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;AACA,wBAAwB,oCAAoC,EAAE;;AAE9D;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,WAAW;EACX,wDAAwD;AAC1D;AACA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA,wEAAwE;AACxE;EACE,oCAAoC;EACpC,kDAAkD;AACpD;AACA;EACE,WAAW,4CAA4C,EAAE;EACzD,MAAM,2CAA2C,EAAE;AACrD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,oFAAoF;EACpF,kDAAkD;AACpD;AACA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;sDACsD;AACtD;EACE;;;0CAGwC,eAAe,EAAE;EACzD,eAAe,wCAAwC,EAAE,YAAY,EAAE;EACvE,iBAAiB,WAAW,EAAE,eAAe,EAAE;EAC/C,gBAAgB,gBAAgB,EAAE;AACpC;;AAEA;EACE,gBAAgB,mBAAmB,EAAE;EACrC,iBAAiB,eAAe,EAAE;AACpC","sourcesContent":["/*\n * Onboarding wizard — two-panel redesign (2026-06-23).\n * Dark brand rail (vertical stepper) + light form panel. Consumes redesign.css\n * tokens; adds a few onboarding-scoped tokens (brand tint, on-dark text).\n * Presentation only — step logic / validation / routing unchanged.\n */\n\n.ob-shell {\n  /* onboarding-scoped tokens (reuse the redesign.css brand ramp) */\n  --brand-tint: #f4f2ff;\n  --t-on-dark: #edeefb;\n  --t-on-dark-dim: #a7abcf;\n\n  display: grid;\n  grid-template-columns: 392px 1fr;\n  min-height: 100vh;\n  background: var(--bg-app, #f4f5fb);\n  color: var(--ink, #0e1124);\n}\n\n/* =====================================================================\n   LEFT BRAND RAIL\n   ===================================================================== */\n.ob-rail {\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  padding: 34px 34px 28px;\n  border-right: 1px solid rgba(255, 255, 255, 0.05);\n  /* Deep blue rail against the light panel. The violet and mint glows keep it\n     from reading as flat navy. */\n  background:\n    radial-gradient(120% 55% at 0% 0%, rgba(139, 123, 255, 0.3), transparent 60%),\n    radial-gradient(80% 50% at 100% 100%, rgba(15, 185, 129, 0.14), transparent 55%),\n    linear-gradient(180deg, #12142e, #0a0c18);\n  color: var(--t-on-dark);\n}\n\n/* The real lockup, not a CSS letter mark. The rail is dark, so it takes\n   maxelpay-logo-light.svg (the white one). The preparing screen is light and\n   uses the -dark.svg variant instead. */\n.ob-logo {\n  display: inline-block;\n  text-decoration: none;\n}\n\n.ob-logo img {\n  height: 34px;\n  width: auto;\n  display: block;\n}\n\n.ob-rail-headline {\n  margin: 40px 0 30px;\n}\n\n.ob-rail-headline h2 {\n  font-family: var(--font-display);\n  font-size: 23px;\n  font-weight: 700;\n  line-height: 1.25;\n  color: #fff;\n}\n\n.ob-rail-headline p {\n  margin-top: 10px;\n  font-size: 13.5px;\n  line-height: 1.5;\n  color: var(--t-on-dark-dim);\n}\n\n.ob-rail-foot {\n  margin-top: auto;\n}\n\n.ob-reassure {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  background: rgba(255, 255, 255, 0.05);\n  /* border: 1px solid rgba(255, 255, 255, 0.08); */\n  border-radius: 12px;\n  padding: 14px 16px;\n}\n\n.ob-reassure-icon {\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n  background: rgba(15, 185, 129, 0.16);\n  color: #4fe3ab;\n  flex-shrink: 0;\n}\n\n.ob-reassure div {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n.ob-reassure a {\n    color: #a99cff;\n    text-decoration: unset;\n}\n.ob-reassure a:hover {\n    color: #ffffff;\n    text-decoration: unset;\n}\n.ob-reassure strong {\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.ob-reassure span {\n  font-size: 12px;\n  color: var(--t-on-dark-dim);\n}\n\n/* A <button>, not a link, since it writes before it navigates. The reset keeps\n   it looking exactly like the link it replaced. */\n.ob-exit {\n  display: inline-block;\n  margin-top: 16px;\n  padding: 0;\n  border: none;\n  background: none;\n  font-family: inherit;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--brand-400, #a99cff);\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.ob-exit:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.ob-exit:hover {\n  color: #fff;\n}\n\n/* =====================================================================\n   VERTICAL STEPPER\n   ===================================================================== */\n.ob-stepper {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.ob-step {\n  position: relative;\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 9px 0;\n}\n\n/* connector above each node */\n.ob-step::before {\n  content: '';\n  position: absolute;\n  left: 14.5px;\n  top: -9px;\n  height: 18px;\n  width: 2px;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.ob-step:first-child::before {\n  display: none;\n}\n\n.ob-step.seg-done::before {\n  background: rgba(15, 185, 129, 0.5);\n}\n\n.ob-step-node {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  place-items: center;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  font-family: var(--font-display);\n  font-size: 13px;\n  font-weight: 700;\n  flex-shrink: 0;\n  border: 2px solid rgba(255, 255, 255, 0.18);\n  color: var(--t-on-dark-dim);\n  background: transparent;\n}\n\n.ob-step.done .ob-step-node {\n  background: var(--ok, #0fb981);\n  border-color: transparent;\n  color: #fff;\n}\n\n.ob-step.current .ob-step-node {\n  background: var(--grad-primary, linear-gradient(135deg, #8270ff, #5847d6));\n  border-color: transparent;\n  color: #fff;\n  box-shadow: 0 0 0 5px rgba(109, 93, 246, 0.22);\n}\n\n.ob-step-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding-top: 5px;\n  min-width: 0;\n}\n\n.ob-step-label {\n  font-size: 14.5px;\n  font-weight: 600;\n  color: var(--t-on-dark-dim);\n}\n\n.ob-step.current .ob-step-label {\n  color: #fff;\n  font-weight: 700;\n}\n\n.ob-step.done .ob-step-label {\n  color: var(--t-on-dark);\n}\n\n.ob-step-caption {\n  display: block;\n  font-size: 11.5px;\n  color: var(--t-on-dark-dim);\n}\n\n/* ═══ Stepper tail: \"Preparing your dashboard\" ══════════════════════════════\n   Replaces what used to be three more numbered circles. Dim and static until\n   the merchant is past step 3, then it animates.\n\n   The motion is deliberately restrained: a slow arc sweep on the node, a\n   shimmer across the label, and a slim indeterminate bar. No percentage, no\n   bounce. It says \"working\" without pretending to know how long.\n   ═════════════════════════════════════════════════════════════════════════ */\n\n.ob-tail { align-items: center; }\n\n/* Node: a hollow ring holding a rotating arc and a centre dot. */\n.ob-tail-node {\n  position: relative;\n  z-index: 1;\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.18);\n  background: transparent;\n}\n.ob-tail-arc {\n  position: absolute;\n  inset: -2px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  /* One visible quarter, so the rotation reads as a sweep rather than a spin\n     of the whole ring. */\n  border-top-color: var(--accent, #6d5df6);\n  opacity: 0;\n}\n.ob-tail-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.24);\n}\n\n.ob-tail-label {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--t-on-dark-dim, #a7abcf);\n}\n\n/* Indeterminate bar. Zero height until active so the row does not shift. */\n.ob-tail-bar {\n  display: block;\n  margin-top: 8px;\n  height: 0;\n  width: 132px;\n  max-width: 100%;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.1);\n  overflow: hidden;\n  opacity: 0;\n  transition: height 0.25s ease, opacity 0.25s ease;\n}\n.ob-tail-bar i {\n  display: block;\n  height: 100%;\n  width: 38%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, transparent, var(--accent, #6d5df6), transparent);\n}\n\n/* ── Active state ─────────────────────────────────────────────────────── */\n\n.ob-tail.is-active .ob-tail-node {\n  border-color: rgba(109, 93, 246, 0.32);\n  box-shadow: 0 0 0 5px rgba(109, 93, 246, 0.14);\n}\n.ob-tail.is-active .ob-tail-arc {\n  opacity: 1;\n  animation: ob-tail-spin 1.15s linear infinite;\n}\n.ob-tail.is-active .ob-tail-dot {\n  background: var(--accent, #6d5df6);\n  animation: ob-tail-breathe 1.9s ease-in-out infinite;\n}\n\n/* Shimmer reads as work in progress. The gradient needs a text clip, so the\n   colour comes from the gradient and not from the token. */\n.ob-tail.is-active .ob-tail-label {\n  /* Light-on-dark: the highlight is white against the dimmed rail text. */\n  background: linear-gradient(\n    100deg,\n    #a7abcf 0%,\n    #a7abcf 38%,\n    #ffffff 50%,\n    #a7abcf 62%,\n    #a7abcf 100%\n  );\n  background-size: 220% 100%;\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  animation: ob-tail-shimmer 2.4s linear infinite;\n}\n\n.ob-tail.is-active .ob-tail-bar { height: 3px; opacity: 1; }\n.ob-tail.is-active .ob-tail-bar i { animation: ob-tail-slide 1.7s ease-in-out infinite; }\n\n@keyframes ob-tail-spin { to { transform: rotate(360deg); } }\n@keyframes ob-tail-breathe {\n  0%, 100% { transform: scale(1); opacity: 0.85; }\n  50% { transform: scale(1.28); opacity: 1; }\n}\n@keyframes ob-tail-shimmer {\n  0% { background-position: 130% 0; }\n  100% { background-position: -30% 0; }\n}\n@keyframes ob-tail-slide {\n  0% { transform: translateX(-105%); }\n  100% { transform: translateX(272%); }\n}\n\n/* Someone who opted out of motion still needs to know it is working, so the\n   label keeps a trailing ellipsis and the bar shows a static partial fill. */\n@media (prefers-reduced-motion: reduce) {\n  .ob-tail.is-active .ob-tail-arc,\n  .ob-tail.is-active .ob-tail-dot,\n  .ob-tail.is-active .ob-tail-label,\n  .ob-tail.is-active .ob-tail-bar i { animation: none; }\n  .ob-tail.is-active .ob-tail-label {\n    background: none;\n    -webkit-text-fill-color: currentColor;\n    color: #fff;\n  }\n  .ob-tail.is-active .ob-tail-label::after { content: '\\2026'; }\n  .ob-tail.is-active .ob-tail-bar i { width: 55%; transform: none; }\n}\n\n\n.ob-logo-image {\n    max-width: 180px;\n}\n.ob-visually-hidden,\n.wiz-visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* =====================================================================\n   RIGHT FORM PANEL\n   ===================================================================== */\n.ob-panel {\n  overflow-y: auto;\n  max-height: 100vh;\n  padding: 42px 40px 48px;\n  background: var(--bg-app, #f4f5fb);\n}\n\n/* Step content container (WizardCard renders <section class=\"wiz-card\">). The\n   panel is the surface, so this is a plain centered column, not a boxed card. */\n.wiz-card {\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n}\n\n/* =====================================================================\n   PROGRESS HEADER (top of every step)\n   ===================================================================== */\n.ob-progress {\n  margin-bottom: 30px;\n}\n\n.ob-progress-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 8px;\n}\n\n.ob-progress-step {\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--brand-700, #5847d6);\n}\n\n.ob-progress-pct {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--ink-muted, #9aa0b6);\n}\n\n.ob-progress-track {\n  height: 6px;\n  background: var(--line, #eaebf3);\n  border-radius: 20px;\n  overflow: hidden;\n}\n\n.ob-progress-fill {\n  height: 100%;\n  border-radius: 20px;\n  background: linear-gradient(90deg, var(--brand-500, #8b7bff), var(--brand-600, #6d5df6));\n  transition: width 0.3s ease;\n}\n\n/* =====================================================================\n   STEP HEADING + BODY\n   ===================================================================== */\n.wiz-card-head {\n  margin-bottom: 24px;\n}\n\n.wiz-title {\n  font-family: var(--font-display);\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--ink, #0e1124);\n  line-height: 1.2;\n}\n\n.wiz-title:focus {\n  outline: none;\n}\n\n.wiz-title:focus-visible {\n  outline: 2px solid var(--brand-400, #a99cff);\n  outline-offset: 4px;\n  border-radius: 4px;\n}\n\n.wiz-subtitle {\n  margin-top: 8px;\n  font-size: 14.5px;\n  color: var(--ink-secondary, #6c7189);\n  line-height: 1.5;\n}\n\n.wiz-card-body {\n  margin-bottom: 4px;\n}\n\n.wiz-form-error {\n  margin-top: 16px;\n  font-size: 13px;\n  color: var(--err-ink, #ce2649);\n  background: var(--err-soft, #fdebef);\n  border: 1px solid var(--err-soft, #fdebef);\n  border-radius: var(--r-md, 12px);\n  padding: 12px 14px;\n}\n\n/* ---- Fields (reuse global .rd-field / .rd-input / .rd-select) ---- */\n.wiz-field {\n  margin-bottom: 18px;\n}\n\n.wiz-field-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n/* =====================================================================\n   FOOTER ACTIONS\n   ===================================================================== */\n.wiz-actions {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  border-top: 1px solid var(--line, #eaebf3);\n  padding-top: 24px;\n  margin-top: 34px;\n}\n\n.wiz-actions-quiet {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-right: auto; /* pushes the primary action to the right */\n}\n\n.wiz-link {\n  background: none;\n  border: none;\n  padding: 6px 2px;\n  color: var(--ink-secondary, #6c7189);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n  font-family: var(--iv-sans);\n}\n\n.wiz-link:hover {\n  color: var(--ink, #0e1124);\n}\n\n/* Continue — brand gradient with a softened lift */\n.wiz-primary.rd-btn,\n.wiz-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 46px;\n  padding: 13px 28px;\n  border: none;\n  border-radius: var(--r-md, 12px);\n  color: #fff;\n  font-weight: 700;\n  font-size: 14.5px;\n  background: var(--grad-primary, linear-gradient(135deg, #8270ff, #5847d6));\n  box-shadow: 0 8px 22px rgba(109, 93, 246, 0.28);\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.wiz-primary:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 10px 26px rgba(109, 93, 246, 0.34);\n}\n\n.wiz-primary:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  box-shadow: none;\n  font-family: var(--iv-sans);\n}\n\n.wiz-secondary {\n  margin-top: 18px;\n  text-align: center;\n  font-size: 14px;\n}\n\n.wiz-secondary button,\n.wiz-secondary a {\n  background: none;\n  border: none;\n  color: var(--brand-600, #6d5df6);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.wiz-secondary button:hover,\n.wiz-secondary a:hover {\n  text-decoration: underline;\n}\n\n/* =====================================================================\n   SELECTABLE OPTION CARD (multi-select grid + single-select radio row)\n   One selection signal only — the styled input carries it.\n   ===================================================================== */\n.sel-card {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n  min-height: 84px;\n  padding: 16px 18px;\n  border: 1.5px solid var(--line, #eaebf3);\n  border-radius: var(--r-lg, 16px);\n  background: var(--surface, #fff);\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;\n}\n\n.sel-card:hover {\n  border-color: var(--brand-400, #a99cff);\n  box-shadow: var(--sh-card, 0 1px 2px rgba(16, 18, 40, 0.04), 0 6px 22px rgba(16, 18, 40, 0.045));\n}\n\n.sel-card.selected {\n  border-color: var(--brand-600, #6d5df6);\n  background: var(--brand-tint, #f4f2ff);\n  box-shadow: 0 0 0 3px rgba(109, 93, 246, 0.1);\n}\n\n.sel-card:focus-within {\n  box-shadow: 0 0 0 3px rgba(109, 93, 246, 0.3);\n}\n\n/* styled real input (checkbox for multi, radio for single) */\n.sel-card-input {\n  appearance: none;\n  -webkit-appearance: none;\n  position: relative;\n  width: 22px;\n  height: 22px;\n  margin: 0;\n  flex-shrink: 0;\n  border: 2px solid var(--border-strong, #dddfec);\n  border-radius: 7px;\n  background: #fff;\n  cursor: pointer;\n  display: grid;\n  place-items: center;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.sel-card-input:checked {\n  background: var(--brand-600, #6d5df6);\n  border-color: var(--brand-600, #6d5df6);\n}\n\n.sel-card-input[type='checkbox']:checked::after {\n  content: '';\n  width: 5px;\n  height: 9px;\n  border: 2px solid #fff;\n  border-top: 0;\n  border-left: 0;\n  transform: translateY(-1px) rotate(45deg);\n}\n\n/* single-select row uses a radio */\n.sel-card.compact {\n  min-height: 0;\n  padding: 15px 18px;\n  border-radius: var(--r-md, 12px);\n}\n\n.sel-card.compact .sel-card-input {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n}\n\n.sel-card.compact .sel-card-input:checked::after {\n  content: '';\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #fff;\n}\n\n.sel-card-icon {\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 12px;\n  background: var(--brand-100, #ece9ff);\n  color: var(--brand-700, #5847d6);\n  flex-shrink: 0;\n}\n\n.sel-card.compact .sel-card-icon {\n  width: 28px;\n  height: 28px;\n  border-radius: 9px;\n}\n\n.sel-card-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n}\n\n.sel-card-label {\n  font-size: 14.5px;\n  font-weight: 600;\n  color: var(--ink, #0e1124);\n}\n\n.sel-card-desc {\n  font-size: 13px;\n  color: var(--ink-secondary, #6c7189);\n  line-height: 1.4;\n}\n\n/* =====================================================================\n   USE-CASE GRID / FIELDSETS / PRIMARY SELECTOR / OPTIONAL SECTION\n   ===================================================================== */\n.wiz-usecase-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n}\n\n.wiz-fieldset {\n  border: none;\n  padding: 0;\n  margin: 0;\n}\n\n.wiz-primary-row {\n  margin-top: 28px;\n}\n\n.wiz-primary-legend {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-family: var(--font-display);\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--ink, #0e1124);\n  margin-bottom: 14px;\n  padding: 0;\n  width: 100%;\n}\n\n.wiz-primary-legend::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: var(--line, #eaebf3);\n}\n\n.wiz-primary-options {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.wiz-optional {\n  margin-top: 28px;\n}\n\n.wiz-optional-divider {\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--ink-muted, #9aa0b6);\n  margin-bottom: 14px;\n}\n\n/* =====================================================================\n   VERIFY (activation handoff) BLOCK\n   ===================================================================== */\n.wiz-handoff {\n  display: flex;\n  gap: 14px;\n  align-items: flex-start;\n  padding: 18px;\n  background: var(--brand-tint, #f4f2ff);\n  border: 1px solid var(--brand-100, #ece9ff);\n  border-radius: var(--r-lg, 16px);\n}\n\n.wiz-handoff-icon {\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  border-radius: var(--r-md, 12px);\n  background: #fff;\n  color: var(--brand-700, #5847d6);\n  flex-shrink: 0;\n}\n\n.wiz-handoff p {\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--ink-secondary, #6c7189);\n}\n\n/* =====================================================================\n   TEST-PAYMENT OPTIONS / CODE / STATUS PILL\n   ===================================================================== */\n.wiz-tp-options {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  margin-bottom: 18px;\n}\n\n.wiz-tp-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  text-align: left;\n  padding: 16px 18px;\n  border: 1.5px solid var(--line, #eaebf3);\n  border-radius: var(--r-lg, 16px);\n  background: var(--surface, #fff);\n  cursor: pointer;\n  transition: border-color 0.15s, box-shadow 0.15s;\n  font-family: var(--iv-sans);\n}\n\n.wiz-tp-option:hover {\n  border-color: var(--brand-400, #a99cff);\n  box-shadow: var(--sh-card, 0 6px 22px rgba(16, 18, 40, 0.045));\n}\n\n.wiz-tp-option-text {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.wiz-tp-option-title {\n  font-size: 14.5px;\n  font-weight: 700;\n  color: var(--ink, #0e1124);\n}\n\n.wiz-tp-option-desc {\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--ink-secondary, #6c7189);\n}\n\n.wiz-tp-code {\n  margin-bottom: 18px;\n  background: var(--ink-900, #0c0e1d);\n  border-radius: var(--r-md, 12px);\n  padding: 16px 18px;\n}\n\n.wiz-tp-code pre {\n  margin: 0;\n  font-family: var(--font-mono);\n  font-size: 12.5px;\n  line-height: 1.6;\n  color: var(--t-on-dark, #edeefb);\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.wiz-pill {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 18px;\n  border-radius: var(--r-md, 12px);\n  border: 1px solid var(--line, #eaebf3);\n  background: var(--bg-inset, #f1f2f8);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--ink-secondary, #6c7189);\n}\n\n.wiz-pill.pending {\n  border-color: var(--warn-soft, #fef3e0);\n  background: var(--warn-soft, #fef3e0);\n  color: var(--warn-ink, #b9760a);\n}\n\n.wiz-pill.succeeded {\n  border-color: var(--ok-soft, #e6f8f1);\n  background: var(--ok-soft, #e6f8f1);\n  color: var(--ok-ink, #0a8f64);\n}\n\n.wiz-pill.failed {\n  border-color: var(--err-soft, #fdebef);\n  background: var(--err-soft, #fdebef);\n  color: var(--err-ink, #ce2649);\n}\n\n.wiz-pill-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: currentColor;\n  flex-shrink: 0;\n  animation: wizPulse 1.2s ease-in-out infinite;\n}\n\n@keyframes wizPulse {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.4; transform: scale(0.7); }\n}\n\n.wiz-retry-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-top: 16px;\n}\n\n.wiz-retry-row .rd-btn {\n  min-width: 140px;\n}\n\n/* =====================================================================\n   SUCCESS (\"You're all set\") — arrival state\n   ===================================================================== */\n.wiz-success-badge {\n  display: grid;\n  place-items: center;\n  width: 76px;\n  height: 76px;\n  border-radius: 50%;\n  margin: 0 auto 22px;\n  background: var(--ok-soft, #e6f8f1);\n  color: var(--ok, #0fb981);\n  box-shadow: 0 0 0 8px rgba(15, 185, 129, 0.08);\n}\n\n/* =====================================================================\n   LOADING SKELETON\n   ===================================================================== */\n.wiz-skeleton {\n  height: 16px;\n  border-radius: 6px;\n  background: linear-gradient(90deg, #eef0f4 25%, #e2e6ee 37%, #eef0f4 63%);\n  background-size: 400% 100%;\n  animation: wizShimmer 1.4s ease infinite;\n}\n\n.wiz-skeleton.block {\n  height: 56px;\n}\n\n@keyframes wizShimmer {\n  0% { background-position: 100% 50%; }\n  100% { background-position: 0 50%; }\n}\n\n/* =====================================================================\n   PLAN STEP — pricing cards on the selectable-card pattern\n   ===================================================================== */\n.wiz-plan {\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n}\n\n.wiz-plan-head {\n  margin-bottom: 26px;\n}\n\n.wiz-plan-title {\n  font-family: var(--font-display);\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: var(--ink, #0e1124);\n}\n\n.wiz-plan-sub {\n  margin-top: 8px;\n  font-size: 14.5px;\n  color: var(--ink-secondary, #6c7189);\n}\n\n.wiz-plan-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  align-items: start;\n}\n\n.wiz-plan-card {\n  position: relative;\n  padding: 24px 22px;\n  display: flex;\n  flex-direction: column;\n  border: 1.5px solid var(--line, #eaebf3);\n  border-radius: var(--r-lg, 16px);\n  background: var(--surface, #fff);\n}\n\n.wiz-plan-card.recommended {\n  border-color: var(--brand-600, #6d5df6);\n  background: var(--brand-tint, #f4f2ff);\n  box-shadow: 0 0 0 3px rgba(109, 93, 246, 0.1);\n}\n\n.wiz-plan-pill {\n  position: absolute;\n  top: -11px;\n  left: 22px;\n  white-space: nowrap;\n  background: var(--grad-primary, linear-gradient(135deg, #8270ff, #5847d6));\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  padding: 5px 11px;\n  border-radius: var(--r-pill, 999px);\n  box-shadow: 0 6px 16px rgba(109, 93, 246, 0.3);\n}\n\n.wiz-plan-card-head {\n  margin-bottom: 16px;\n}\n\n.wiz-plan-name {\n  font-family: var(--font-display);\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--ink, #0e1124);\n}\n\n.wiz-plan-card.recommended .wiz-plan-name {\n  color: var(--brand-700, #5847d6);\n}\n\n.wiz-plan-tagline {\n  margin-top: 4px;\n  font-size: 13px;\n  color: var(--ink-secondary, #6c7189);\n}\n\n.wiz-plan-price {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n  padding-bottom: 14px;\n  margin-bottom: 14px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.wiz-plan-currency {\n  font-family: var(--font-display);\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--ink-muted, #9aa0b6);\n}\n\n.wiz-plan-amount {\n  font-family: var(--font-display);\n  font-size: 40px;\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: -0.02em;\n  color: var(--ink, #0e1124);\n}\n\n.wiz-plan-amount.text {\n  font-size: 30px;\n}\n\n.wiz-plan-period {\n  font-size: 13px;\n  color: var(--ink-muted, #9aa0b6);\n}\n\n.wiz-plan-fee {\n  font-size: 13px;\n  color: var(--ink-secondary, #6c7189);\n  margin-bottom: 18px;\n}\n\n.wiz-plan-fee-value {\n  font-family: var(--font-mono);\n  font-weight: 700;\n  color: var(--ink, #0e1124);\n}\n\n.wiz-plan-card.recommended .wiz-plan-fee-value {\n  color: var(--brand-700, #5847d6);\n}\n\n.wiz-plan-fee-save {\n  color: var(--brand-600, #6d5df6);\n  font-weight: 600;\n}\n\n.wiz-plan-cta {\n  min-height: 44px;\n}\n\n.wiz-plan-cta-note {\n  margin-top: 8px;\n  text-align: center;\n  font-size: 12px;\n  color: var(--ink-muted, #9aa0b6);\n}\n\n.wiz-plan-features {\n  margin-top: 18px;\n}\n\n.wiz-plan-features-heading {\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--ink-muted, #9aa0b6);\n  margin-bottom: 12px;\n}\n\n.wiz-plan-features ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.wiz-plan-features li {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--ink-secondary, #6c7189);\n}\n\n.wiz-plan-features li svg {\n  color: var(--ok, #0fb981);\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.wiz-plan-features li.muted {\n  color: var(--ink-muted, #9aa0b6);\n}\n\n.wiz-plan-features li.muted svg {\n  color: var(--ink-muted, #c7cbdb);\n}\n\n.wiz-plan-foot {\n  display: flex;\n  justify-content: flex-start;\n  border-top: 1px solid var(--line, #eaebf3);\n  padding-top: 24px;\n  margin-top: 28px;\n}\n\n/* =====================================================================\n   RESPONSIVE  (≤900px → single column; rail becomes a slim top bar)\n   ===================================================================== */\n@media (min-width: 768px) {\n  .wiz-plan-grid {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n\n@media (max-width: 900px) {\n  .ob-shell {\n    grid-template-columns: 1fr;\n  }\n\n  .ob-rail {\n    position: static;\n    height: auto;\n    flex-direction: row;\n    align-items: center;\n    gap: 16px;\n    padding: 14px 18px;\n    border-right: none;\n    border-bottom: 1px solid var(--line, #eaebf3);\n  }\n\n  .ob-logo {\n    flex-shrink: 0;\n  }\n\n  /* hide everything except the step nodes */\n  .ob-rail-headline,\n  .ob-rail-foot,\n  .ob-step-text,\n  .ob-tail-text {\n    display: none;\n  }\n\n  .ob-stepper {\n    display: flex;\n    align-items: center;\n    gap: 0;\n    overflow-x: auto;\n    flex: 1;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .ob-step {\n    padding: 0 20px 0 0;\n    flex-shrink: 0;\n  }\n\n  /* Tail keeps its node in the strip; its label lives in .ob-tail-text, hidden\n     above, so the animating ring is the whole signal on narrow screens. */\n  .ob-tail { padding-right: 0; }\n\n  .ob-step::before {\n    left: -20px;\n    top: 14px;\n    height: 2px;\n    width: 20px;\n  }\n\n  .ob-step:first-child::before {\n    display: none;\n  }\n\n  .ob-panel {\n    max-height: none;\n    overflow-y: visible;\n    padding: 28px 18px 40px;\n  }\n\n  .wiz-title {\n    font-size: 23px;\n  }\n\n  .wiz-usecase-grid,\n  .wiz-tp-options,\n  .wiz-field-row {\n    grid-template-columns: 1fr;\n  }\n\n  .wiz-plan-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .wiz-actions {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n\n  .wiz-primary {\n    width: 100%;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .wiz-primary,\n  .ob-progress-fill,\n  .sel-card,\n  .sel-card-input,\n  .wiz-tp-option,\n  .wiz-pill-dot,\n  .wiz-skeleton {\n    transition: none;\n    animation: none;\n  }\n}\n\n\n/* ═══ Preparing screen ══════════════════════════════════════════════════════\n   Full-bleed handoff between the wizard and the dashboard. Same brand ground as\n   the rail, so leaving setup is a continuation rather than a jump.\n   ═════════════════════════════════════════════════════════════════════════ */\n\n.ob-prep {\n  min-height: 100vh;\n  display: grid;\n  place-items: center;\n  padding: 40px 24px;\n  /* Light ground, matching the rail the merchant just left. */\n  background:\n    radial-gradient(90% 45% at 50% 0%, rgba(109, 93, 246, 0.09), transparent 64%),\n    var(--surface, #ffffff);\n  color: var(--ink, #0e1124);\n  font-family: var(--font-sans);\n}\n\n.ob-prep-inner {\n  width: 100%;\n  max-width: 360px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.ob-prep-logo {\n  display: inline-block;\n  margin-bottom: 42px;\n}\n\n.ob-prep-logo img {\n  height: 34px;\n  width: auto;\n  display: block;\n}\n\n/* Ring: one sweeping arc around a soft core. Bigger sibling of the rail tail. */\n.ob-prep-ring {\n  position: relative;\n  width: 62px;\n  height: 62px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  border: 2px solid var(--line, #eaebf3);\n}\n.ob-prep-arc {\n  position: absolute;\n  inset: -2px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  border-top-color: var(--accent, #6d5df6);\n  animation: ob-prep-spin 1.05s linear infinite;\n}\n.ob-prep-core {\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background: var(--grad-primary, linear-gradient(135deg, #8270ff, #5847d6));\n  box-shadow: 0 0 20px rgba(109, 93, 246, 0.45);\n  animation: ob-prep-breathe 1.9s ease-in-out infinite;\n}\n@keyframes ob-prep-spin { to { transform: rotate(360deg); } }\n@keyframes ob-prep-breathe {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.2); }\n}\n\n.ob-prep-title {\n  margin: 26px 0 0;\n  font-family: var(--font-display);\n  font-size: 22px;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: var(--ink, #0e1124);\n}\n.ob-prep-sub {\n  margin: 9px 0 0;\n  font-size: 13.5px;\n  color: var(--ink-muted, #6c7189);\n}\n\n/* Task list. Left-aligned inside a centred column: a ticking checklist reads as\n   a list, and centring it makes the ticks wander as labels change width. */\n.ob-prep-tasks {\n  list-style: none;\n  margin: 30px 0 0;\n  padding: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  text-align: left;\n}\n.ob-prep-task {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 9px 12px;\n  border-radius: 10px;\n  font-size: 13.5px;\n  color: var(--t-400, #9aa0b6);\n  transition: color 0.3s ease, background 0.3s ease;\n}\n.ob-prep-task.is-active {\n  color: var(--ink, #0e1124);\n  background: var(--accent-soft, #ece9ff);\n}\n.ob-prep-task.is-done { color: var(--ink-secondary, #3b4059); }\n\n.ob-prep-tick {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  border: 1.5px solid var(--line-strong, #dddfec);\n  color: #fff;\n  transition: background 0.3s ease, border-color 0.3s ease;\n}\n.ob-prep-task.is-done .ob-prep-tick {\n  background: var(--ok, #0fb981);\n  border-color: transparent;\n}\n/* The active row's marker pulses so the eye knows which line is live. */\n.ob-prep-task.is-active .ob-prep-tick {\n  border-color: var(--accent, #6d5df6);\n  animation: ob-prep-pulse 1.2s ease-in-out infinite;\n}\n@keyframes ob-prep-pulse {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(109, 93, 246, 0.35); }\n  50% { box-shadow: 0 0 0 5px rgba(109, 93, 246, 0); }\n}\n\n.ob-prep-bar {\n  display: block;\n  margin-top: 30px;\n  width: 100%;\n  height: 3px;\n  border-radius: 999px;\n  background: var(--bg-inset, #eff0f8);\n  overflow: hidden;\n}\n.ob-prep-bar i {\n  display: block;\n  height: 100%;\n  width: 34%;\n  border-radius: 999px;\n  background: linear-gradient(90deg, transparent, var(--accent, #6d5df6), transparent);\n  animation: ob-prep-slide 1.6s ease-in-out infinite;\n}\n@keyframes ob-prep-slide {\n  0% { transform: translateX(-105%); }\n  100% { transform: translateX(300%); }\n}\n\n/* Reduced motion: the component already renders every task done and exits\n   quickly, so this only has to stop the decoration. */\n@media (prefers-reduced-motion: reduce) {\n  .ob-prep-arc,\n  .ob-prep-core,\n  .ob-prep-bar i,\n  .ob-prep-task.is-active .ob-prep-tick { animation: none; }\n  .ob-prep-arc { border-top-color: var(--accent, #6d5df6); opacity: 0.7; }\n  .ob-prep-bar i { width: 100%; transform: none; }\n  .ob-prep-task { transition: none; }\n}\n\n@media (max-width: 520px) {\n  .ob-prep-logo { margin-bottom: 32px; }\n  .ob-prep-title { font-size: 20px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
